import React, {useState, useEffect} from 'react';
import Rating from '@material-ui/lab/Rating';
import Checkbox from '@material-ui/core/Checkbox';
import {
    makeStyles,
    RadioGroup,
    Radio,
    TextField,
    Box,
    Fab,
    FormControl,
    FormGroup,
    FormControlLabel,
    FormHelperText,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Button
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import {getQrtClient, postRpsQrt} from './resources/services/questionnaireClient'

const useStyles = makeStyles(theme => ({
    container: {
        flexWrap: 'wrap',
    },
    margin: {
        margin: '5% auto',
    },
    extendedIcon: {
        marginRight: theme.spacing(3),
    },
    root: {
        display: 'flex',
        maxHeight: '80%',
        height: 'inherit'
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    button: {
        margin: theme.spacing(1),
    },
    input: {
        display: 'none',
    },

    Rating: {
        fontSize: '2.5rem'
    },
    Paper: {
        display: 'container',


    },

    Div: {
        width: '80%',
        display: 'block',
        margin: '0 10%'
    },

    Box: {
        'padding-top': '2%',
        paddingBottom: '2%',
        width: 'auto',

    },

    Form: {
        margin: '5% auto',
        width: '60%'
    },
    Altilogo: {
        width: 'auto',
    },

    AltilogoForm: {
        margin: ' 0 auto',
        width: 'auto',
    },

    DivLogo: {
        textAlign: 'center',
        width: '100%',
        margin: 'auto'
    },

    DivLogoForm: {
        textAlign: 'center',
        width: '100%',
    },

    Comm: {
        fontSize: '1.5em'
    },

    h1: {
        'align': 'center',
    },
    checkboxLabel: {
        fontSize: '1.2em'
    },

    Txt: {
        margin: '5% 2% 0 2%'
    },

    ModalHeader: {
        color: 'white',
        backgroundColor: '#003b5e',
        '& h2':{
            fontSize: '1.5em'
        }
    },
    ModalConfirm: {
        color: 'white',
        backgroundColor: '#EF9700',
    },
    ModalAnnul: {
        color: 'white',
        backgroundColor: '#003b5e',
    }

}));

const QuestionnaireClient = (oldprops) => {
    const classes = useStyles();
    const [props] = useState(oldprops);
    const [valueRadio, setValueRadio] = React.useState();
    const [errorText, setErrorText] = React.useState('');
    const [valueQcm] = React.useState();
    const [isLoading, setIsLoading] = React.useState(true);
    const [isAnswered, setIsAnswered] = React.useState(false);
    const [isFalse, setIsFalse] = React.useState(false);
    const [isLate, setIsLate] = React.useState(false);
    const [hasBeenAnswered, setHasBeenAnswered] = React.useState(false);
    const [notAnswered, setNotAnswered] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [lstQst, setLstQst] = useState([{
            qstId: '',
            qstTxT: '',
            tpe: {
                tpeId: '',
                tpeLibelle: '',
            }
        }]
    );

    const labels = {
        1: 'Très insatisfaisant',
        2: 'Insatisfaisant',
        3: 'Satisfaisant',
        4: 'Très satisfaisant',
    };

    function IconContainer(props) {
        const {value, ...other} = props;
        return (
            <Tooltip title={labels[value] || ''}>
                <div  {...other} />
            </Tooltip>
        );
    }

    IconContainer.propTypes = {
        value: PropTypes.number.isRequired,
    };

    useEffect(() => {
        getQClient()
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = (event) => {
        event.preventDefault();
        setOpen(true);
    };

    async function getQClient() {
        const {match: {params: {token}}} = props;
        // eslint-disable-next-line no-restricted-globals
        const listQst = [];
        await getQrtClient(token)
            .then(response => {
                response.data.map(qt => listQst.push(qt));
                setLstQst(listQst);
                setIsLoading(false);
            }).catch(function (error) {
                if (error.response.status === 403) {
                    setIsAnswered(true);
                    setIsLoading(false);
                } else if (error.response.status === 409) {
                    setIsLate(true);
                    setIsLoading(false);
                } else if (error.response.status === 404) {
                    setIsFalse(true);
                    setIsLoading(false);
                }
            });
    }

    function sendResponse(event) {
        // eslint-disable-next-line no-restricted-globals
        setNotAnswered(false);
        const {match: {params: {token}}} = props;
        event && event.preventDefault();
        if(valueRadio) {
            let test = Object.keys(valueRadio).length;
            lstQst.map(question => {
                if (question.tpe.tpeLibelle === 'commentaire') {
                    if (!Object.keys(valueRadio).includes('qstOpt_' + question.qstId)) {
                        test++;
                    }
                } else if (question.qstMere) {
                    let qstMere = 'qst_' + question.qstMere;
                    if (valueRadio[qstMere].value > 2) {
                        test++;
                    }
                }
            });
            if (test === lstQst.length) {
                setIsLoading(true);
                postRpsQrt([token, valueRadio])
                    .then(response => {
                        setIsLoading(false);
                        setHasBeenAnswered(true);
                    }).catch(function (error) {
                    if (error.response.status === 403) {
                        setIsAnswered(true);
                        setIsLoading(false);
                        setOpen(false);
                    } else if (error.response.status === 409) {
                        setIsLate(true);
                        setIsLoading(false);
                        setOpen(false);
                    } else if (error.response.status === 404) {
                        setIsFalse(true);
                        setIsLoading(false);
                        setOpen(false);
                    }
                });
            } else {
                setNotAnswered(true);
                setOpen(false);
            }
        }else {
            setNotAnswered(true);
            setOpen(false);
        }
    }

    function qcmInsatisfait(id) {
        if (valueRadio && valueRadio["qst_" + id] && valueRadio["qst_" + id].value < 3) {
            return (
                <div>
                    {lstQst.map(question => {
                            if (question.qstMere === id) {
                                return (
                                    <Box key={question.qstId} className={classes.Box} component="fieldset"
                                         borderColor="transparent">
                                        <h4>{question.qstTxt}</h4>
                                        <FormGroup aria-label="position"
                                                   onChange={(e) => onChange(e, "qst_" + question.qstId, 'qcm')}
                                        >
                                            <FormControlLabel
                                                control={<Checkbox/>}
                                                value="Test1;"
                                                label="Test1"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox/>}
                                                value="Test2;"
                                                label="Test2"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox/>}
                                                value="Test3;"
                                                label="Test3"
                                            />
                                        </FormGroup>
                                    </Box>
                                )
                            }
                        }
                    )
                    }
                </div>
            )
        }
    }

    function onChange(event, questionID, type) {
        var vRadio = event.target.value;

        if (type === 'note') {
            setValueRadio(valueRadio => ({...valueRadio, [questionID]: {value: vRadio, qcm: []}}));
        } else if (type === 'qcm') {
            if (valueRadio) {
                if (valueRadio[questionID]) {
                    if (valueRadio[questionID].includes(vRadio)) {
                        if (valueRadio[questionID].replace(vRadio, '') === '') {
                            delete valueRadio[questionID];
                            setValueRadio(valueRadio);
                        } else {
                            setValueRadio(valueRadio => ({
                                ...valueRadio,
                                [questionID]: valueRadio[questionID].replace(vRadio, '')
                            }));
                        }
                    } else {
                        setValueRadio(valueRadio => ({
                            ...valueRadio,
                            [questionID]: valueRadio[questionID].concat('', vRadio)
                        }));
                    }
                } else {
                    setValueRadio(valueRadio => ({...valueRadio, [questionID]: vRadio}));
                }
            } else {
                setValueRadio(valueRadio => ({...valueRadio, [questionID]: vRadio}));
            }

        } else if (type === 'comm') {
            let regexTxt = /^[a-zA-Z 0-9,()éç'èà-]{0,200}$/;
            if (vRadio.match(regexTxt)) {
                setValueRadio(valueRadio => ({...valueRadio, [questionID]: vRadio}));
                setErrorText("");
            } else {
                setErrorText("Caractères non autorisés détectés, la réponse ne sera pas prise en compte");
                delete valueRadio[questionID];
                setValueRadio(valueRadio);
            }
        } else {
            setValueRadio(valueRadio => ({...valueRadio, [questionID]: vRadio}));
        }
    }

    if (isLoading) {
        return (
            <div className={classes.DivLogo}>
                <h2 className={classes.Txt}>Chargement en cours, merci de patienter...</h2>
            </div>
        );
    } else if (isFalse) {
        return (
            <div className={classes.DivLogo}>
                <h2 className={classes.Txt}>L'intervention à laquelle vous tentez d'accéder est incorrecte.</h2>
            </div>
        );
    } else if (isAnswered) {
        return (
            <div className={classes.DivLogo}>
                <h2 className={classes.Txt}>Ce questionnaire a déjà été validé, nous vous remercions pour votre
                    participation</h2>
            </div>
        );
    } else if (isLate) {
        return (
            <div className={classes.DivLogo}>
                <h2 className={classes.Txt}>Ce questionnaire n'est plus actif.</h2>
            </div>
        );
    } else if (hasBeenAnswered) {
        return (
            <div className={classes.DivLogo}>
                <h2 className={classes.Txt}>Merci pour votre participation.</h2>
            </div>
        );
    } else {
        return (
            <div className={classes.Div}>
                <div className={classes.DivLogoForm}>
                    <h2>Questionnaire de satisfaction</h2>
                    <p>Bonjour Madame, Monsieur,<br/>
                        A la suite de votre raccordement à la fibre optique, nous souhaitons connaître votre niveau de
                        satisfaction.<br/>
                        Pour répondre à cette enquête, pouvez-vous sélectionner le nombre d’étoiles pour chaque
                        question.
                        L’échelle est de 1 à 4, une étoile correspond à "très insatisfait" et quatre étoiles à "très
                        satisfait".<br/>
                        A la fin du questionnaire, veuillez cliquer sur le bouton "Valider" pour enregistrer votre
                        notation
                        et
                        commentaires éventuels.</p>
                </div>
                <form className={classes.root} onSubmit={(e) => handleOpen(e)}>
                    <FormControl className={classes.Form} id="myform">
                        {lstQst.map(question => {
                                if (!question.qstMere) {
                                    if (question.tpe.tpeLibelle === 'directe') {
                                        return (
                                            <Box key={question.qstId} className={classes.Box} component="fieldset"
                                                 borderColor="dark">
                                                <h4>{question.qstTxt}</h4>
                                                <RadioGroup aria-label="position" name={'qst_' + question.qstId}
                                                            value={valueRadio && valueRadio['qst_' + question.qstId]}
                                                            onChange={(e) => onChange(e, 'qst_' + question.qstId, 'direct')}
                                                >
                                                    <FormControlLabel
                                                        classes={{
                                                            label: classes.checkboxLabel
                                                        }}
                                                        value="Oui"
                                                        control={<Radio color="primary" required={true}/>}
                                                        label="Oui"
                                                        labelPlacement="end"
                                                        className={classes.Radio1}
                                                    />
                                                    <FormControlLabel
                                                        classes={{
                                                            label: classes.checkboxLabel
                                                        }}
                                                        value="Non"
                                                        control={<Radio color="primary" required={true}/>}
                                                        label="Non"
                                                        labelPlacement="end"
                                                        className={classes.Radio2}
                                                    />
                                                </RadioGroup>
                                                {notAnswered && !(valueRadio && valueRadio['qst_' + question.qstId]) ?
                                                    <FormHelperText error style={{fontSize : '1em'}}>Veuillez répondre à la
                                                        question</FormHelperText> : null}
                                            </Box>
                                        )
                                    }
                                    if (question.tpe.tpeLibelle === 'note') {
                                        return (
                                            <Box key={question.qstId} className={classes.Box} component="fieldset"
                                                 borderColor="transparent">
                                                <h4>{question.qstTxt}</h4>
                                                <Rating
                                                    name={'qst_' + question.qstId}
                                                    value={valueRadio && valueRadio['qst_' + question.qstId] && valueRadio['qst_' + question.qstId].value}
                                                    onChange={(e) => {
                                                        onChange(e, 'qst_' + question.qstId, 'note');
                                                    }}
                                                    max={4}
                                                    IconContainerComponent={IconContainer}
                                                    className={classes.Rating}
                                                />
                                                {/*{qcmInsatisfait(question.qstId)}*/}
                                                {notAnswered && !(valueRadio && valueRadio['qst_' + question.qstId] && valueRadio['qst_' + question.qstId].value) ?
                                                    <FormHelperText error style={{fontSize : '1em'}}>Veuillez répondre à la
                                                        question</FormHelperText> : null}
                                            </Box>
                                        )
                                    }
                                    if (question.tpe.tpeLibelle === 'commentaire') {
                                        return (
                                            <Box key={question.qstId} className={classes.Box} component="fieldset"
                                                 borderColor="transparent">
                                                <h4>{question.qstTxt}</h4>
                                                <TextField
                                                    style={{margin: 'auto'}}
                                                    fullWidth
                                                    name={'qstOpt_' + question.qstId}
                                                    variant="outlined"
                                                    helperText={errorText}
                                                    className={classes.Comm}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onChange={(e) => onChange(e, 'qstOpt_' + question.qstId, 'comm')}
                                                />
                                            </Box>
                                        )
                                    }
                                    if (question.tpe.tpeLibelle === 'qcm') {
                                        return (
                                            <Box key={question.qstId} className={classes.Box} component="fieldset"
                                                 borderColor="transparent">
                                                <h4>{question.qstTxt}</h4>
                                                <FormGroup aria-label="position"
                                                           onChange={(e) => onChange(e, "qst_" + question.qstId, 'qcm')}
                                                >
                                                    <FormControlLabel
                                                        control={<Checkbox/>}
                                                        value="Test1;"
                                                        label="Test1"
                                                    />
                                                    <FormControlLabel
                                                        control={<Checkbox/>}
                                                        value="Test2;"
                                                        label="Test2"
                                                    />
                                                    <FormControlLabel
                                                        control={<Checkbox/>}
                                                        value="Test3;"
                                                        label="Test3"
                                                    />
                                                </FormGroup>
                                            </Box>
                                        )
                                    }
                                }
                            }
                        )
                        }
                        <Fab variant="extended" type="submit" size="small" color="primary" aria-label="Add"
                             className={classes.margin}>Valider le questionnaire</Fab>
                    </FormControl>
                </form>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle className={classes.ModalHeader} id="form-dialog-title">Valider le formulaire</DialogTitle>
                    <DialogContent>
                        Valider le formulaire vous empêchera de le modifier par la suite, cette action est irréversible.
                        Souhaitez-vous continuer?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant="contained"  className={classes.ModalAnnul}>
                            Annuler
                        </Button>
                        <Button onClick={(e) => sendResponse(e)} variant="contained" className={classes.ModalConfirm}>
                            Valider
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}
export default QuestionnaireClient;